import React from 'react';
import {
  Box,
  Progress,
  Text,
  List,
  ListItem,
  ListIcon,
  VStack,
} from '@chakra-ui/react';
import { CheckCircleIcon, WarningIcon } from '@chakra-ui/icons';

const PasswordStrengthIndicator = ({ validationResult }) => {
  const {
    strength,
    strengthText,
    strengthColor,
    requirements
  } = validationResult;

  return (
    <VStack spacing={2} align="stretch" mt={2}>
      <Box>
        <Text fontSize="sm" mb={1}>Password Strength: {strengthText}</Text>
        <Progress
          value={(strength / 5) * 100}
          size="sm"
          colorScheme={
            strength <= 1 ? 'red' :
            strength === 2 ? 'orange' :
            strength === 3 ? 'yellow' :
            'green'
          }
          borderRadius="full"
        />
      </Box>
      
      <List spacing={1} mt={2}>
        {requirements.map((req) => (
          <ListItem
            key={req.id}
            fontSize="sm"
            color={req.isMet ? 'green.500' : 'gray.500'}
            display="flex"
            alignItems="center"
          >
            <ListIcon
              as={req.isMet ? CheckCircleIcon : WarningIcon}
              color={req.isMet ? 'green.500' : 'gray.500'}
            />
            {req.message}
          </ListItem>
        ))}
      </List>
    </VStack>
  );
};

export default PasswordStrengthIndicator;
